'use client'

import { ButtonLink } from '@repo/shared/components'
import { useTranslate } from '@repo/shared/hooks'
import { useUserPortfolio } from '@repo/services'
import { Col, Icon, Row, Skeleton, Typography } from '@repo/ui/components'
import Image from 'next/image'
import { useParams } from 'next/navigation'
import { useMemo } from 'react'

export const HistoryBalanceAssetHeaderLayout = () => {
  const { t } = useTranslate()
  const { id } = useParams()
  const { data: { data: { accounts = [] } = {} } = {}, isLoading } =
    useUserPortfolio()

  const account = useMemo(() => {
    return accounts?.find((account) => account.currency === id)
  }, [accounts, id])

  return (
    <Col className='gap-xs py-xs'>
      <ButtonLink
        variant='transparent'
        color='neutral'
        size='md'
        href='/wallet'
        startIcon={<Icon name='ArrowRightLine' size='md' />}
      >
        {t('common_back')}
      </ButtonLink>
      <Row className='justify-between gap-md'>
        {isLoading ? (
          <Row>
            <Skeleton className='w-36 h-md bg-white' />
          </Row>
        ) : (
          <Row className='gap-xs'>
            <Image
              src={`/images/${account?.currency === 'MALEK' ? 'club-gem' : account?.currency}.svg`}
              alt={account?.currency ?? ''}
              width={24}
              height={24}
            />

            <Typography size='lg' weight='bold'>
              {account?.currency === 'MALEK'
                ? t('walletPage_malek_balance')
                : account?.currency}
            </Typography>
          </Row>
        )}

        <Row className='w-fit gap-xs'>
          {id !== 'MALEK' && (
            <ButtonLink
              href={`/assets/${id}?type=sell`}
              size='sm'
              variant='ghost'
              color='negative'
              width='full'
            >
              {t('walletPage_sell_in_market')}
            </ButtonLink>
          )}
          <ButtonLink
            href='/square-token'
            size='xs'
            variant='transparent'
            width='full'
            color='neutral'
            startIcon={<Icon name='QuestionMarkRtlCircleLine' size='xs' />}
          >
            {t('common_more_details')}
          </ButtonLink>
          <ButtonLink
            href={`/quick-trade?projectId=${id}&type=sell`}
            size='sm'
            variant='fill'
            color='negative'
            width='full'
          >
            {t('walletPage_sell_in_market_instant')}
          </ButtonLink>
        </Row>
      </Row>
    </Col>
  )
}
